/**********************************************************************
 *
 * Copyright (C) 2026 Almendo Technologies GmbH
 * Copyright (C) 2026 Marcus Harringer
 *
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of
 * Marcus Harringer. The intellectual and technical concepts contained
 * herein are proprietary to Marcus Harringer and may be covered
 * copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Marcus Harringer.
 *
 ***********************************************************************/
import { generateClient } from 'aws-amplify/api';

// One GraphQL client for all API modules: AppSync endpoint and auth mode (user pool tokens) from the Amplify config
const client = generateClient();

export default client;
